export default [
  {
    title: 'breadcrumb.report',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'breadcrumb.overview',
        route: 'conversation-overview',
        icon: '',
        resource: ['report-conversation-overview', 'report-call-center-overview'],
        action: 'read',
      },
      {
        title: 'breadcrumb.satisfaction',
        route: 'customer-satisfaction',
        icon: '',
        resource: ['report-customer-satisfaction', 'report-call-satisfaction'],
        action: 'read',
      },
      {
        title: 'breadcrumb.performance',
        route: 'team-performance',
        icon: '',
        resource: 'report-team-performance',
        action: 'read',
      },
      {
        title: 'breadcrumb.summaryConversation',
        route: 'conversation-summary',
        icon: '',
        resource: 'summary-conversation',
        action: 'read',
      },
      // {
      //   title: 'breadcrumb.conversationOverview',
      //   route: 'conversation-overview',
      //   icon: '',
      //   resource: 'report-conversation-overview',
      //   action: 'read',
      // },
      // {
      //   title: 'breadcrumb.callCenterOverview',
      //   route: 'call-center-overview',
      //   icon: '',
      //   resource: 'report-call-center-overview',
      //   action: 'read',
      // },
      // {
      //   title: 'breadcrumb.teamPerformance',
      //   route: 'team-performance',
      //   icon: '',
      //   resource: 'report-team-performance',
      //   action: 'read',
      // },
      // {
      //   title: 'breadcrumb.customerSatification',
      //   route: 'customer-satification',
      //   icon: '',
      //   resource: 'report-customer-satisfaction',
      //   action: 'read',
      // },
      // {
      //   title: 'breadcrumb.callSatisfaction',
      //   route: 'call-satisfaction',
      //   icon: '',
      //   resource: 'report-call-satisfaction',
      //   action: 'read',
      // },
      // {
      //   title: 'breadcrumb.summaryConversation',
      //   route: 'conversation-summary',
      //   icon: '',
      //   resource: 'summary-conversation',
      //   action: 'read',
      // },
    ],
  },
]
